function MiniDonut() {
  this.params = function(percentage) {
    const radius = 20
    const innerRadius = radius - 1
    return {
      radius: radius,
      innerRadius: innerRadius,
      diameter: 2 * radius,
      offset: (100 - percentage) / 100 * innerRadius * 2 * Math.PI,
      percentage: percentage,
    }
  }
}